import { render, staticRenderFns } from "./KeyValueForm.vue?vue&type=template&id=bc557888"
import script from "./KeyValueForm.vue?vue&type=script&lang=js"
export * from "./KeyValueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports